<template>
  <CaseStudy
    title="WOLF"
    :logo="require('@/assets/logos/hayden.png')"
    :thumbnail="require('@/assets/screenshots/wolf.png')"
    iframeLink="https://iframe.bubblemaps.io/map/TxtiUGMPmlZ8WutSW0Hn?partnerId=demo"
    threadLink="https://x.com/bubblemaps/status/1900928487365427562"
    :featuredIn="[
      {
        name: 'Cointelegraph',
        logo: require('@/assets/logos/medias/cointelegraph.png'),
        link: 'https://cointelegraph.com/news/libra-melania-creator-wolf-wall-street-memecoin-crashes-99',
        color: '#F7C02C',
      },
      {
        name: 'TheBlock',
        logo: require('@/assets/logos/medias/theblock.png'),
        link: 'https://www.theblock.co/post/346504/libra-token-facilitator-hayden-davis-connected-to-40-million-crash-of-wolf-memecoin-bubblemaps',
      },
      {
        name: 'Bitget',
        logo: require('@/assets/logos/medias/bitget.png'),
        link: 'https://www.bitget.com/news/detail/12560604646948',
        color: '#03AAC1',
      },
    ]"
  >
    How Hayden Davis launched a bundled meme coin called WOLF while under
    <b>Interpol red notice</b>
  </CaseStudy>
</template>

<script>
import CaseStudy from "@/components/organisms/CaseStudies/CaseStudy.vue";

export default {
  components: {
    CaseStudy,
  },
};
</script>
